import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";

export const useGetConexionesDetalleColumns = (getChipEstado) => {

    const initialColumns = [
        {
            width: 140,
            field: "idIndicacion",
            headerName: "Indicación",
            align: "center",
            headerAlign: "center"
        },
        {
            width: 110,
            field: "numeroDia",
            headerName: "# Día",
        },
        {
            width: 110,
            field: "fecha",
            headerName: "Fecha",
            type: "date",
        },
        {
            width: 140,
            field: "idConexion",
            headerName: "# Conexión",
        },
        {
            width: 140,
            field: "estadoAbreviacion",
            headerName: "Estado",
            align:"center",
            headerAlign: "center",
            renderCell: ({ row }) => getChipEstado(row?.estadoAbreviacion)
        },

    ];

    const columns = useMemo(
        () => generateColumnsDefaultConfiguration(initialColumns, true),
        []
    );

    return columns;
}